export enum UserRoleEnum {
  XemexAdmin = 'Xemex_admin',
  XemexSupport = 'Xemex_support',
  XemexProduction = 'Xemex_production',
  PartnerAdmin = 'Partner_admin',
  PartnerUser = 'Partner_user',
  InstallerAdmin = 'Installer_admin',
  SubInstallerAdmin = 'Subinstaller_admin',
  Mechanic = 'Mechanic',
}
